import { getQueryString } from "api/search/filterUrlMaker";
import { getCookie } from "react-use-cookie";
import { isProdEnv } from "lib/routing";

export function createReportUrl(pid, ext, appName, cid, japi) {
  const prefix = window.location.protocol + "//";
  let host = getHost();
  let path = getPubPath(pid, ext, appName, cid, japi);

  const url = prefix + host + path;
  return url;
}

export function createImageUrl(pid, fileName = "coverImage.png") {
  const prefix = window.location.protocol + "//";
  let host = getHost();
  let path = `/research/japi/publication/${pid}/image/${fileName}`;
  const url = prefix + host + path;
  return url;
}

export function sourceFromQueryString() {
  return getQueryString().source
    ? getQueryString().source.split(",")
    : ["synopsis", "gicsIndustryGroups", "reportTypes", "customData"];
}

export function getEsIndex() {
  return getQueryString()["es-index"] || getCookie("grp-es-index");
}

function getHost() {
  let host;
  if (isProdEnv || getEsIndex() === "PUBLICATION_PRODCOPY") {
    host = "go.nomuranow.com";
  } else {
    host = window.location.host.replace(/(intranet|www).nomuranow.com/, "go.nomuranow.com");
  }
  return host;
}

const getPubPath = (pid, ext, appName, cid, japi = "japi") =>
  `/research/${japi}/publication/${pid}${ext}?appname=${appName}`;
